import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface DarkStore {
    id: string;
    [key: string]: any;
}

interface DarkStoreListResponse {
    darkStores: DarkStore[];
    total: number;
    page: number;
    totalPages: number;
}

interface DarkStoreState {
    data: DarkStoreListResponse | null;
    loading: boolean;
    error: string | null;
}

export interface DarkStoreUpdatePayload {
    id: string;
    [key: string]: any;
}

const initialState: DarkStoreState = {
    data: null,
    loading: false,
    error: null,
};

const darkStoreSlice = createSlice({
    name: "darkStores",
    initialState,
    reducers: {
        setDarkStoreList(state, action: PayloadAction<DarkStoreListResponse>) {
            console.log(action,'acc')
            state.data = action.payload;
            state.loading = false;
        },

        addDarkStore(state, action: PayloadAction<any>) {
            const details = action.payload;
            if (!details) return;

            const newDarkStore: DarkStore = {
                ...details,
                id: details.id,
            };

            if (state.data?.darkStores) {
                state?.data?.darkStores?.unshift(newDarkStore);
                state.data.total += 1;

                if (state.data.darkStores?.length > 10) {
                    state?.data?.darkStores?.pop();
                }
            } else {
                state.data = {
                    darkStores: [newDarkStore],
                    total: 1,
                    page: 1,
                    totalPages: 1,
                };
            }
        },

        darkStoreUpdate(state, action: PayloadAction<DarkStoreUpdatePayload>) {
            const { id, ...updates } = action.payload;
            if (!id || !state.data) return;

            const darkStore = state.data.darkStores.find((p) => p.id === id);
            if (darkStore) {
                Object.assign(darkStore, updates);
            }
        },

        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },

        setError(state, action: PayloadAction<string | null>) {
            state.error = action.payload;
        },
    },
});

// ✅ Export actions
export const { setDarkStoreList, addDarkStore, darkStoreUpdate, setLoading, setError } =
    darkStoreSlice.actions;

// ✅ Export reducer
export default darkStoreSlice.reducer;
